export const today = 'Сегодня';
export const yesterday = 'Вчера';
